import Vue from 'vue'
import Vuex from 'vuex'
import getters from '@/store/getters.js'
import actions from '@/store/actions.js'
import mutations from '@/store/mutations.js'
import state from '@/store/state.js'

import createPlugin from 'logrocket-vuex';
import LogRocket from 'logrocket';
const logrocketPlugin = createPlugin(LogRocket);

Vue.use(Vuex)

export default new Vuex.Store({
	strict: process.env.NODE_ENV !== 'production',
	state,
	mutations,
	actions,
	getters,
	plugins: [logrocketPlugin]
})
